var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Coding-Apps-Website-Web-Dev-Api-Cloud--Streamline-Ultimate.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coding Apps Website Web Dev Api Cloud Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.694 13.716c1.3994 0.0236 2.7508 -0.5096 3.757 -1.4823 1.0063 -0.9727 1.5851 -2.3053 1.609 -3.70465 -0.0242 -1.39918 -0.6031 -2.73148 -1.6093 -3.70397 -1.0063 -0.97249 -2.3575 -1.50557 -3.7567 -1.48203 -0.454 -0.00004 -0.9064 0.05537 -1.347 0.165 -0.4093 -0.83329 -1.0455 -1.53416 -1.8353 -2.02204 -0.7899 -0.487888 -1.7013 -0.742983 -2.6297 -0.735962C9.67079 0.732053 8.49661 1.16749 7.59001 1.97085c-0.90661 0.80337 -1.48015 1.91663 -1.60801 3.1212 -1.08844 0.08432 -2.10621 0.57189 -2.85402 1.36724 -0.74782 0.79535 -1.17182 1.84119 -1.18898 2.93276 0.02051 1.16575 0.5029 2.27575 1.3412 3.08615 0.83831 0.8103 1.96399 1.2548 3.1298 1.2358l10.284 0.002Z",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.245 23.2501v-6.534",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.938 16.7161h2.613",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.938 23.25h2.613",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.097 23.25v-2.614",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.1 20.6361h1.96c0.5198 0 1.0184 -0.2065 1.3859 -0.5741 0.3676 -0.3676 0.5741 -0.8661 0.5741 -1.3859 0 -0.5199 -0.2065 -1.0184 -0.5741 -1.386 -0.3675 -0.3675 -0.8661 -0.574 -1.3859 -0.574H11.1v3.92Z",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.94901 23.2499 0.737 -4.919c0.07157 -0.446 0.29971 -0.852 0.64351 -1.145 0.3438 -0.293 0.78075 -0.454 1.23249 -0.454 0.45173 0 0.88868 0.161 1.23248 0.454 0.3438 0.293 0.57194 0.699 0.64352 1.145l0.738 4.919",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.29201 20.9629h4.541",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApi);
export default __webpack_public_path__ + "static/media/icon-API.f108d218aed22dc8bf654b5a75df5be9.svg";
export { ForwardRef as ReactComponent };